//phpcs:disable

import convert from 'json-form-data';

export default {
    data() {
        return {
            loading: false,
            multipartData: false,
        };
    },
    methods: {
        resetErrorMessages() {
            let vueObject = this;

            vueObject.globalErrors = [];

            _.each(this.errorMessages, function (messages, field) {
                vueObject.errorMessages[field] = [];
            });
        },

        submit: function (url, data, method, successCallback, errorCallback) {
            if (!this.$refs.form.validate()) {
                return;
            }

            this.loading = true;

            this.resetErrorMessages();

            if (method === undefined) {
                method = 'post';
            }

            let postData = data;
            let headers = {};

            if (this.multipartData) {
                let options = {
                    initialFormData: new FormData(),
                    showLeafArrayIndexes: true,
                    includeNullValues: true,
                    mapping: function (value) {
                        if (typeof value === 'boolean') {
                            return +value ? '1' : '0';
                        }

                        if (value === null) {
                            return '';
                        }

                        return value;
                    },
                };

                if (method.toLowerCase() === 'put') {
                    postData._method = 'put';
                    method = 'post';
                }

                postData = convert(postData, options);

                headers = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                };
            }

            axios({
                method: method,
                url: url,
                headers: headers,
                data: postData,
            }).then(
                (result) => {
                    this.loading = false;
                    if (successCallback !== undefined) {
                        successCallback(result);
                    }
                },
                (error) => {
                    this.loading = false;

                    if (!error.response) {
                        return;
                    }

                    if (error.response.status === 422) {
                        let vueObject = this;

                        _.each(error.response.data.errors, function (fieldErrors) {
                            if (fieldErrors.field && vueObject.errorMessages[fieldErrors.field] !== undefined) {
                                vueObject.errorMessages[fieldErrors.field] = fieldErrors.errors;
                            } else {
                                vueObject.globalErrors = fieldErrors.errors;
                            }
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }

                    if (errorCallback !== undefined) {
                        errorCallback(error);
                    }
                }
            );
        },
    },
};
